export enum WebhookStatus {
  CREATED = 'CREATED',
  RETRYING = 'RETRYING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
}

export enum WebhookEventType {
  CREATED = 'CREATED',
  RETRYING = 'RETRYING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  RESEND = 'RESEND',
}

export enum Permission {
  ADMIN = 'ADMIN',
  READ = 'READ',
  WRITE = 'WRITE',
  GROUP_ONLY = 'GROUP_ONLY',
}

export enum AuditStatus {
  CREATED = 'CREATED',
  AWAITING_REVIEW = 'AWAITING_REVIEW',
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  ISSUE_REPORTED = 'ISSUE_REPORTED',
  REQUESTED = 'REQUESTED',
  VERIFIED = 'VERIFIED',
}

export enum AuditMediaStatus {
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}

export enum AuditFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
}

export enum PartnerStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  PENDING_INACTIVATION = 2,
}

export enum PartnerRiskRating {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export enum SubscriptionStatus {
  CANCELLED = 'CANCELLED',
  NO_PAY = 'NO_PAY',
  NO_ID = 'NO_ID',
  ACTIVE = 'ACTIVE',
  NO_ACCOUNT = 'NO_ACCOUNT',
  PENDING_CANCELLATION = 'PENDING_CANCELLATION',
}

export enum MailStatus {
  ACCOUNT_FROZEN = 'ACCOUNT_FROZEN',
  AWAITING_FORWARD = 'AWAITING_FORWARD',
  AWAITING_FORWARD_RELEASED = 'AWAITING_FORWARD_RELEASED',
  AWAITING_MACHINE_SCAN = 'AWAITING_MACHINE_SCAN',
  COLLECTED = 'COLLECTED',
  CREATED = 'CREATED',
  DESTROYED = 'DESTROYED',
  FORWARDED = 'FORWARDED',
  FORWARDED_ON_HOLD_NO_ID = 'FORWARDED_ON_HOLD_NO_ID',
  ON_HOLD_INVOICE = 'ON_HOLD_INVOICE',
  ON_HOLD_KYC_ID = 'ON_HOLD_KYC_ID',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  REFUSED = 'REFUSED',
  REJECTED = 'REJECTED',
  REQUESTED_FORWARD = 'REQUESTED_FORWARD',
  REQUESTED_SCAN = 'REQUESTED_SCAN',
  RETURNED = 'RETURNED',
  SCANNED = 'SCANNED',
  SCANNED_ON_HOLD_NO_ID = 'SCANNED_ON_HOLD_NO_ID',
  SPAM = 'SPAM',
}

export enum GroupRole {
  OWNER = 'OWNER',
  MEMBER = 'MEMBER',
}

export enum CancellationTermination {
  END_OF_TERM = 'END_OF_TERM',
  IMMEDIATE = 'IMMEDIATE',
}

export enum CancellationReason {
  REQUESTED = 'Requested',
  DEFAULTED = 'Defaulted',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum CustomerStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING_INACTIVATION = 'PENDING_INACTIVATION',
}

export enum DocumentType {
  ID = 'ID',
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  AUDIT_REPORT = 'AUDIT_REPORT',
}

export enum AuthType {
  SOCIAL = 'SOCIAL',
  EMAIL = 'EMAIL',
}

export enum RoleName {
  PARTNER_ADMIN = 'PARTNER_ADMIN',
  USER_WRITE = 'USER_WRITE',
  USER_READ = 'USER_READ',
  GROUP_READ = 'GROUP_READ',
}

export enum NotificationType {
  GROUP = 'GROUP',
  CUSTOMER = 'CUSTOMER',
}

export enum VeriffStatus {
  CREATED = 'CREATED',
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  RESUBMISSION = 'RESUBMISSION',
  EXPIRED = 'EXPIRED',
  REVIEW = 'REVIEW',
}

export enum MailActionType {
  SCAN = 'SCAN',
  FORWARD = 'FORWARD',
  DOWNLOAD = 'DOWNLOAD',
  RESEND = 'RESEND',
}

export enum KYCStatus {
  NotChecked = 'NotChecked',
  CheckedPassed = 'CheckedPassed',
  CheckedFailed = 'CheckedFailed',
}

// Same values as KYCStatus but semantically different - used for AML checks
export enum AMLCheckStatus {
  NotChecked = 'NotChecked',
  CheckedPassed = 'CheckedPassed',
  CheckedFailed = 'CheckedFailed',
}

export enum BillingPeriod {
  MONTHLY = 1,
  ANNUAL = 2,
}

export enum BusinessType {
  LIMITED_COMPANY = 'LIMITED_COMPANY',
  SOLE_TRADER = 'SOLE_TRADER',
  CHARITY = 'CHARITY',
  UNINCORPORATED = 'UNINCORPORATED',
  TRUST = 'TRUST',
  ASSOCIATION = 'ASSOCIATION',
}

export enum APIBusinessType {
  LIMITED_COMPANY = 1,
  SOLE_TRADER = 3,
  CHARITY = 10,
  UNINCORPORATED = 9,
  TRUST = 12,
  ASSOCIATION = 13,
}

export enum PartnerRole {
  ADMIN = 0,
  PARTNER_ADMIN = 1,
  USER_WRITE = 2,
  USER_READ = 3,
  GROUP_READ = 4,
}
